const apiUrl = process.env.REACT_APP_API_URL;

const getFluidTypes = (token, cb) => {
    fetch(`${apiUrl}/fluidtypes`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getFluidTypes;
